export default "__VITE_ASSET__BWr23gnC__"